// 接口文档：http://api-doc-sl.inshopline.com/#/project/80/feature%2F20210907_v1.0.0/interface/671bf86f9ad6f2e706d9bba65bc2d6ce
export default {
  list: '/api/addresses/list',
  addressConfig: '/api/countries/config',
  getAddressVerify: '/api/countries/verify',

  saveAddress: '/api/address-books/save',
  addressList: '/api/address-books/list',
}
